"use client";
import { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";
import { Button } from "@/components/ui/button";

export function NavBar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 0);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`w-full bg-primary flex items-center justify-between px-4 md:px-8 py-4 sticky top-0 z-30 transition-all duration-200 ${
        scrolled ? "border-b border-primary" : "border-b-0"
      }`}
    >
      <Link href="/" className="flex items-center gap-2">
        <Image
          src="/batchfinderLogo.png"
          alt="BatchFinder Logo"
          width={56}
          height={56}
          priority
        />
      </Link>
      <div className="flex items-center gap-2">
        <Link href="/login" className="mr-2">
          <span className="font-semibold text-white hover:underline cursor-pointer text-base">
            Login
          </span>
        </Link>
        <Link href="/signup">
          <Button className="rounded-full bg-white text-primary font-semibold px-5 py-2 text-base shadow-sm hover:scale-[1.03] transition-all">
            Sign up
          </Button>
        </Link>
      </div>
    </nav>
  );
}
